<template>
  <div
    :class="[
      'VisualButton',
      {
        isActive: isActive,
        fitWidth: variant.width === 'fit',
        smallWidth: variant.smallWidth === 'true',
        disabled: variant.type === 'disabled',
        focus: variant.focus
      }
    ]"
    :style="{ color: variant.color }"
    @click="variant.type === 'disabled' ? null : _onClickButton($event)"
  >
    <p>
      {{ text }}
      <sup
        v-if="annotation"
        class="annotation"
      >
        {{ annotation }}
      </sup>
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      imgDetail: false,
    };
  },
  props: {
    text: String,
    annotation: {
      type: String,
      default: "",
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: Object,
      default: () => ({ color: "black" }),
    },
  },
  created () {},
  components: {},
  methods: {
    _onClickButton ($event) {
      this.$emit("click", $event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

$--focused-border: 2px solid $--color-primary;

.VisualButton {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  min-width: 13vw;
  padding: 0 7px;
  border: 2px solid $--border-color-base;
  font-size: 18px;
  font-weight: bold;
  border-radius: 2px;
  white-space: nowrap;
  display: inline-flex;
}

.fitWidth {
  min-width: auto;
}

.smallWidth {
  min-width: 8vw;
  width: 11vw;
}

.isActive {
  background: $background-blue-lighter;
  border: $--focused-border;
}

.disabled {
  color: $text-extra-light; // #dcdcdc;
}

.focus {
  border: $--focused-border;
}

.annotation {
  font-size: 11.5px;
  margin-left: -5px;
  margin-right: -15px;
}
</style>
